import { string } from "prop-types";
import React from "react";
import {
 multilanguage
} from "redux-multilanguage";

const MobileSearch = ({strings}) => {
    return (
        <div className="offcanvas-mobile-search-area">
            <form action="#">
                <input type="search" placeholder={strings['product']['search']} />
                <button type="submit">
                    <i className="fa fa-search" />
                </button>
            </form>
        </div>
    );
};

export default multilanguage(MobileSearch);
